export enum AuthenticatorStep {
    ChooseMethod = 'chooseMethod',
    SetupAuthenticator = 'setupAuthenticator',
    SetupAuthenticatorEnterCode = 'setupAuthenticatorEnterCode',
    Confirmation = 'confirmation',
    BackupCodes = 'backupCodes',
}

export enum AuthenticatorType {
    AuthenticatorApp = 'authenticatorApp',
    PhoneNumber = 'phoneNumber',
}
